import axios from 'axios';
import * as types from '../constants/ActionTypes';

import { formalQuickAnswerKey } from '../../lib/page';
import { quickAnswerLayer } from '../constants/UtilVariables';

const RELATED_ARTICLE_URL = '/smarthelp/related-article';
const WEB_TREE_URL = '/smarthelp/web-topic-tree';

// For Find Quick Answer Layer 1 data
function requestRelatedTopic() {
  return {
    type: types.REQUEST_RELATED_TOPIC,
  };
}

function receiveRelatedTopic(responseData) {
  return {
    type: types.RECEIVE_RELATED_TOPIC_RESPONSE,
    payload: responseData,
  };
}

function receiveRelatedTopicError() {
  return {
    type: types.RECEIVE_RELATED_TOPIC_ERROR,
  };
}

function fetchRelatedTopic(topicId) {
  return (dispatch) => {
    dispatch(requestRelatedTopic());
    return axios.get(`${RELATED_ARTICLE_URL}?topic=${topicId}`)
    .then(response => (
      dispatch(receiveRelatedTopic(response.data))
    ))
    .catch(() => (
      dispatch(receiveRelatedTopicError())
    ));
  };
}

// For Quick Anwser Layer 2 topics and suggested related articles
function requestWebTreeTopic() {
  return {
    type: types.REQUEST_WEB_TREE_TOPICS,
  };
}

function receiveWebTreeTopic(responseData) {
  return {
    type: types.RECEIVE_WEB_TREE_TOPICS,
    payload: responseData,
  };
}

function receiveWebTreeError() {
  return {
    type: types.RECEIVE_WEB_TREE_TOPICS_ERROR,
  };
}

function fetchWebTreeTopic(topicId) {
  return (dispatch) => {
    dispatch(requestWebTreeTopic());
    return axios.get(`${WEB_TREE_URL}?q=${topicId}`)
    .then(response => (
      dispatch(receiveWebTreeTopic(response.data && response.data.webTopicTree))
    ))
    .catch(() => (
      dispatch(receiveWebTreeError())
    ));
  };
}

// For each select tracking for Find quick Anwser
function selectTopic({ layer, topicId }) {
  return {
    type: types.SELECT_QUICK_TOPIC,
    payload: {
      layer,
      topicId: formalQuickAnswerKey({ layer, topicId }),
    },
  };
}

function selectQuickAnswer({ layer, topicId }) {
  return (dispatch) => {
    dispatch(selectTopic({ layer, topicId }));
    if (layer === quickAnswerLayer.layer1) {
      dispatch(fetchWebTreeTopic(topicId));
    }
  };
}

module.exports = {
  fetchRelatedTopic,
  fetchWebTreeTopic,
  selectQuickAnswer,
};
